// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"b35fb766","495":"4ba55cf3","624":"a15d7624","648":"1dcad472","769":"81057293","885":"78392c8b","968":"167f5055"}[chunkId] + ".chunk.js";
};